import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';

const WonItemsPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const description = formatMessage({ id: 'get_in_on_the_auction' });
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'won_items' }));
    const canonical = `${baseUrl}/dashboard/won-items`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default React.memo(WonItemsPageHeaderMeta);
